import React from 'react';
import { t as uiText } from '../../i18n';
import { isNcgSeries } from '../../features/plans/series';
import './NcgLaunchOfferNotice.css';

/** 日本の消費税 10%。表示は税抜価格にこの率を掛けた税込総額。Checkout の実額は住所で再計算される。 */
const JP_TAX_RATE = 1.1;

const EXCL_YEN: Record<string, number> = {
  'NCG:starter': 14800,
  'NCN:starter': 1000,
  'NCN:standard': 5000,
  'NCN:team': 14800,
};

function yen(amount: number): string {
  return `¥${amount.toLocaleString('ja-JP')}`;
}

export function regularMonthlyPrice(
  seriesId: string | undefined,
  planId: string
): { excl: string; incl: string } | null {
  const series = isNcgSeries(seriesId) ? 'NCG' : 'NCN';
  const excl = EXCL_YEN[`${series}:${planId}`];
  if (!excl) return null;
  return { excl: yen(excl), incl: yen(Math.round(excl * JP_TAX_RATE)) };
}

export const NcgLaunchOfferNotice: React.FC<{ part?: 'all' | 'resubscribe' }> = ({ part = 'all' }) => (
  <div className="ncg-launch-offer-notice">
    {part === 'all' && (
      <p>
        {uiText(
          'From the first signup, the launch price applies to the first 12 monthly payments while that same subscription continues. Those payments are ¥9,800 per month (excl. tax; ¥10,780 including 10% Japan consumption tax). From the 13th payment, the regular price of ¥14,800 per month applies (excl. tax; ¥16,280 including tax). You can cancel during that period.'
        )}
      </p>
    )}
    <p>
      {uiText(
        'If you cancel the subscription yourself, or if it is canceled automatically because every payment retry failed, a new signup after cancellation does not receive the launch price. The regular price of ¥14,800 per month applies (excl. tax; ¥16,280 including 10% Japan consumption tax).'
      )}
    </p>
  </div>
);

export const PaidPlanRenewalNotice: React.FC<{ seriesId?: string; planId: string }> = ({
  seriesId,
  planId,
}) => {
  const price = regularMonthlyPrice(seriesId, planId);
  if (!price) return null;
  return (
    <p className="paid-plan-renewal-notice">
      {uiText(
        '{{priceExcl}} per month, excluding tax. With 10% Japan consumption tax, the total is {{priceIncl}} per month. This plan renews automatically every month. You can cancel before the next renewal.',
        { priceExcl: price.excl, priceIncl: price.incl }
      )}
    </p>
  );
};
